export default __webpack_public_path__ + "static/media/aws1.c243c202.jpg";